import { render, staticRenderFns } from "./transfer_stock.vue?vue&type=template&id=1cf8751f&"
import script from "./transfer_stock.vue?vue&type=script&lang=js&"
export * from "./transfer_stock.vue?vue&type=script&lang=js&"
import style0 from "./transfer_stock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports